export const ROPSTEN_TOKEN_LIST = {
  name: 'KyberSwap Token List',
  keywords: ['kyberswap', 'dmmexchange'],
  timestamp: '2020-12-12T00:00:00+00:00',
  tokens: [
    {
      chainId: 3,
      address: '0x8B4DDF9F13f382aff76D262F6C8C50E6d7961b94',
      symbol: 'KNC',
      name: 'Kyber Network Crystal',
      decimals: 18,
    },
    {
      chainId: 3,
      address: '0x7b2810576aa1cce68f2b118cef1f36467c648f92',
      symbol: 'KNCL',
      name: 'Kyber Network Crystal Legacy',
      decimals: 18,
    },
    {
      chainId: 3,
      address: '0x068B43f7F2f2c6a662C36E201144aE45f7a1C040',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 3,
      address: '0x65Bd1F48f1dd07bb285a3715c588F75684128acE',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 3,
      address: '0xaD6D458402F60fD3Bd25163575031ACDce07538D',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 3,
      address: '0x3dff0dce5fc4b367ec91d31de3837cf3840c8284',
      symbol: 'WBTC',
      name: 'WBTC',
      decimals: 8,
    },
    {
      chainId: 3,
      address: '0xa748593dD74E5d0BB38a3f2F5090a0f31370c574',
      symbol: 'renBTC',
      name: 'renBTC',
      decimals: 8,
    },
    {
      chainId: 3,
      address: '0xb4f7332ed719eb4839f091eddb2a3ba309739521',
      symbol: 'LINK',
      name: 'LINK',
      decimals: 18,
    },
    {
      chainId: 3,
      address: '0xdb0040451f373949a4be60dcd7b6b8d6e42658b6',
      symbol: 'BAT',
      name: 'BAT',
      decimals: 18,
    },
    {
      chainId: 3,
      address: '0x787e7339a52d7784a22146da7209c702e1e38511',
      symbol: 'COMP',
      name: 'COMP',
      decimals: 18,
    },
    {
      chainId: 3,
      address: '0x5f4F41E067e8cCF0d1F9EE007223aF4D72990cdC',
      symbol: 'AAVE',
      name: 'AAVE',
      decimals: 18,
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
